import Header from './header.js';
import Navigation from './navigation.js';
import Search from './search.js';
import LangSwitcher from './lang-switcher.js';

// Header
const header = document.querySelector('#header');

if(header) {
	new Header(header);

	// Navigation
	const navigation = header.querySelector('#navigation');

	if(navigation) {
		new Navigation(navigation);
	}

	// Search
	const search = header.querySelector('#search');

	if(search) {
		new Search(search);
	}

	// Lang switcher
	const langSwitcher = header.querySelectorAll('[data-lang-switcher]');

	if(langSwitcher) {
		langSwitcher.forEach(item => {
			new LangSwitcher(item);
		});
	}
}
